<template>
  <div class="nps-rating">
    <div class="nps-rating-container">
      <div ref="nps" v-bind="{ ...item }" @change="handleChange" class="nps-score-list">
        <div
          v-for="n in 11"
          :key="n"
          class="nps-score"
          :class="{ active: isActive(n) }"
          :style="{ backgroundColor: isActive(n) ? getColor(item.npsBackgroundColor, n - 1) : '' }"
          @click="handleClick(n - 1)"
        >
          {{ n - 1 }}
        </div>
      </div>
      <div v-if="item['show-auxiliary-text']" class="flex-row el-nps-labels">
        <p class="q-score-text">{{ item.textLeft }}</p>
        <p class="q-score-text" style="text-align: center">{{ item.textCenter }}</p>
        <p class="q-score-text" style="text-align: right">{{ item.textRight }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '../mixin'

export default {
  name: 'NpsRating',
  mixins: [mixin],
  props: ['models'],
  data() {
    return {
      oldValue: null
    }
  },
  methods: {
    handleChange(val) {
      this.changeValue = val

      // 重复点击说明是想取消
      if (this.changeValue === this.oldValue) {
        this.changeValue = ''
        this.oldValue = null
        this.initValue = 0
      } else {
        this.oldValue = val
      }
    },
    handleClick(index) {
      const newValue = this.changeValue === index ? null : index
      this.changeValue = newValue
    },
    getColor(baseColor, index) {
      // 选中的颜色为10分的颜色，1-9依次颜色递减变淡, 设置初始值为0.5透明度，依次增加0.05
      const alpha = 0.5 + index * 0.05
      return this.hexToRgba(baseColor, alpha)
    },
    hexToRgba(hex, alpha) {
      hex = hex.replace(/^#/, '')
      // 考虑三位数颜色的情况，如 #f90 => #ff9900
      if (hex.length === 3) {
        hex = hex
          .split('')
          .map((c) => c + c)
          .join('')
      }
      // 转成整数
      const r = parseInt(hex.substr(0, 2), 16)
      const g = parseInt(hex.substr(2, 2), 16)
      const b = parseInt(hex.substr(4, 2), 16)
      return `rgba(${r}, ${g}, ${b}, ${alpha})`
    },
    isActive(n) {
      const { changeValue } = this
      return changeValue > n - 1 || changeValue === n - 1
    }
  }
}
</script>

<style lang="scss" scoped>
.nps-rating {
  border-radius: 8px;
  &-container {
    max-width: 375px;
  }
}
.nps-score-list {
  display: flex;
}
.nps-score {
  flex: 1;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
  display: inline-block;
  box-sizing: border-box;
  height: 28px;
  line-height: 28px;
  width: 26px;
  text-align: center;
  border: 1px solid #dcdfe6;
  color: #606266;
  &:not(:first-child) {
    border-left: none;
  }
  &.active {
    color: #fff;
    border: none;
  }
}
.el-nps-labels {
  width: 100%;
  display: flex;
  justify-content: space-between;
  font-size: 16px;
  .q-score-text {
    flex: 1;
    color: #909299;
  }
}
</style>
